export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      quote: "This AI receptionist has completely transformed how we handle customer calls. We've seen a 40% increase in appointment bookings and our customers love the instant response time.",
      name: "Sarah Mitchell",
      role: "CEO, HealthCare Plus",
      avatar: "https://public.readdy.ai/ai/img_res/e0142c6bf49b118e150558d32db8adf5.jpg"
    },
    {
      rating: 5,
      quote: "The multi-language support is a game-changer for our international clients. We can now serve customers in their native language 24/7 without hiring additional staff.",
      name: "Carlos Rodriguez",
      role: "Operations Manager, Global Logistics",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20businessman%20with%20warm%20smile%2C%20corporate%20headshot%2C%20modern%20office%20setting%2C%20business%20suit%2C%20approachable%20demeanor&width=200&height=200&seq=avatar-002&orientation=squarish"
    },
    {
      rating: 5,
      quote: "I was skeptical at first, but the natural conversation quality is incredible. Our clients can't even tell they're talking to an AI. It's like having a full-time receptionist at a fraction of the cost.",
      name: "Jennifer Lee",
      role: "Founder, Lee & Associates Law",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Asian%20businesswoman%20with%20confident%20expression%2C%20corporate%20portrait%2C%20elegant%20business%20attire%2C%20professional%20lighting&width=200&height=200&seq=avatar-003&orientation=squarish"
    },
    {
      rating: 5,
      quote: "The analytics dashboard gives us insights we never had before. We can see call patterns, peak times, and customer inquiries at a glance. It's helped us optimize our entire operation.",
      name: "Michael Chen",
      role: "Director of Operations, TechStart Inc",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20businessman%20with%20glasses%2C%20tech%20industry%20executive%2C%20modern%20corporate%20headshot%2C%20smart%20casual%20attire&width=200&height=200&seq=avatar-004&orientation=squarish"
    },
    {
      rating: 5,
      quote: "Setup was incredibly easy and the integration with our existing CRM was seamless. We were up and running in less than an hour. Best business decision we've made this year.",
      name: "Amanda Foster",
      role: "Marketing Director, Bright Solutions",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20businesswoman%20with%20creative%20style%2C%20marketing%20executive%20portrait%2C%20modern%20workspace%2C%20confident%20and%20friendly&width=200&height=200&seq=avatar-005&orientation=squarish"
    },
    {
      rating: 5,
      quote: "Our customer satisfaction scores have increased by 35% since implementing this AI receptionist. The 24/7 availability means we never miss an opportunity, even outside business hours.",
      name: "David Thompson",
      role: "Owner, Thompson Real Estate",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20real%20estate%20agent%20with%20welcoming%20smile%2C%20business%20portrait%2C%20professional%20attire%2C%20trustworthy%20appearance&width=200&height=200&seq=avatar-006&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-block px-4 py-2 bg-purple-100 text-purple-600 rounded-full text-xs font-bold tracking-wider mb-4">
            TRUSTED BY THOUSANDS
          </div>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            What Our Customers<br />Are Saying
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Star Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed mb-6 text-base">
                "{testimonial.quote}"
              </p>

              {/* Divider */}
              <div className="border-t border-gray-200 opacity-50 mb-6"></div>

              {/* Author Info */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                  <p className="text-gray-600 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
